// App default for attention-directing scrolls; instant scrolls (navigation
// position restores) are a different concept and must not use this.
export const smoothScrollIntoView = (element: Element, options?: ScrollIntoViewOptions): void =>
	element.scrollIntoView({ behavior: 'smooth', block: 'start', ...options });
